import axios from "axios";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const STORAGE_KEY = "mc_admin_token";

export const tokenStore = {
  get: () => localStorage.getItem(STORAGE_KEY),
  set: (t) => localStorage.setItem(STORAGE_KEY, t),
  clear: () => localStorage.removeItem(STORAGE_KEY),
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      tokenStore.clear();
      // Avoid redirect loop on login screen
      if (!window.location.pathname.startsWith("/admin/login")) {
        toast.error("Session expired. Please log in again.");
        window.location.assign("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
